export interface Size3 {
  x: number;
  y: number;
  z: number;
}

/**
 * Distance from the model's centre at which the whole bounding box fits the frame, both in
 * height and width (a tall full-body figure in a narrow phone-sized stage is width-bound).
 */
export function fitDistance(size: Size3, fovDeg: number, aspect: number, margin = 1.25): number {
  const halfFov = (Math.max(1, Math.min(120, fovDeg)) * Math.PI) / 360;
  const safeAspect = Math.max(0.1, aspect);
  const byHeight = size.y / 2 / Math.tan(halfFov);
  const byWidth = Math.max(size.x, size.z) / 2 / (Math.tan(halfFov) * safeAspect);
  return Math.max(byHeight, byWidth) * margin + size.z / 2;
}

/** Zoom limits relative to the framing distance, so users cannot lose or clip the model. */
export function zoomLimits(distance: number): { min: number; max: number } {
  return { min: distance * 0.35, max: distance * 3 };
}
